import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox as AriaCheckbox } from '@ariakit/react';
import { forwardRef } from 'react';
import { CheckboxCheckmark, Minus } from '../Icons';
import * as Styles from './styles';
const Checkbox = ({ children, checked, indeterminate = false, disabled, hover, ...rest }) => {
    const filled = checked || indeterminate;
    return (_jsxs(_Fragment, { children: [_jsx(Styles.Checkbox, { "$filled": filled, "$disabled": disabled, "$hover": hover && !indeterminate, ...rest, children: indeterminate ? (_jsx(Minus, { "aria-hidden": true, height: '10px', stroke: 'white', viewBox: '0 0 12 2', width: '10px' })) : (_jsx(CheckboxCheckmark, { "aria-hidden": true })) }), children] }));
};
const Label = ({ children, disabled, ...rest }) => {
    return (_jsx(Styles.Label, { "$disabled": disabled, ...rest, children: children }));
};
const Input = forwardRef(function Input({ disabled, indeterminate, checked, ...rest }, ref) {
    return (_jsx(AriaCheckbox, { ref: ref, disabled: disabled, accessibleWhenDisabled: true, checked: indeterminate ? 'mixed' : checked, render: _jsx(Styles.HiddenInput, {}), ...rest }));
});
export const StyledCheckbox = {
    Checkbox,
    Label,
    Input,
    AriaKitCheckbox: Styles.AriaKitCheckbox,
};
//# sourceMappingURL=index.js.map